import { render } from "./OneUsefulInformation.vue?vue&type=template&id=603da817&scoped=true"
import script from "./OneUsefulInformation.vue?vue&type=script&lang=js"
export * from "./OneUsefulInformation.vue?vue&type=script&lang=js"

import "./OneUsefulInformation.vue?vue&type=style&index=0&id=603da817&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-603da817"]])

export default __exports__